import Logger from '../Log'
import FillMethod from './FillMethod'
import { divIsEmpty, ecpmOrDefault, loadScript, playerDims } from '../utils'

const Log = Logger.for('DistroScaleFillMethod')

export class DistroScaleFillMethod extends FillMethod {
  constructor (bidder) {
    super('distroscale', bidder, 'video', ecpmOrDefault(bidder.params.ecpm, 1))
  }

  fill (slot, media) {
    return new Promise((resolve, reject) => {
      const url = '//c.jsrdn.com/s/cs.js?p=22928'

      const div = document.createElement('div')
      div.id = 'ds_default_anchor'
      slot.node().appendChild(div)

      loadScript(url, slot.node())
        .then((s) => {
          Log.debug('Distro tag loaded')
          slot.resource(s)

          setTimeout(() => {
            if (!divIsEmpty(div)) {
              Log.info('Distro tag loaded content')

              const dims = playerDims(media, {})
              return resolve({
                width: dims[0],
                height: dims[1],
                cpm: this.estValue()
              })
            } else {
              Log.warn('Distro script didnt load any content')
              slot.resetNode()
              return resolve({ cpm: 0 })
            }
          }, 3000)
        })
    })
  }
}
